import { Action } from '@ngrx/store';
import { ProjectSet } from './project-set.model';

export const ADD = '[ProjectSet] Add';
export const ADD_COMPLETE = '[ProjectSet] Add Complete';
export const ADD_FAILED = '[ProjectSet] Add Failed';

export const UPDATE = '[ProjectSet] Update';
export const UPDATE_COMPLETE = '[ProjectSet] Update Complete';
export const UPDATE_FAILED = '[ProjectSet] Update Failed';

export const DELETE = '[ProjectSet] Delete';
export const DELETE_COMPLETE = '[ProjectSet] Delete Complete';
export const DELETE_FAILED = '[ProjectSet] Delete Failed';

export class AddAction implements Action {
    readonly type = ADD;

    constructor(public payload: ProjectSet) { }
}

export class AddCompleteAction implements Action {
    readonly type = ADD_COMPLETE;

    constructor(public payload: ProjectSet) { }
}

export class AddFailedAction implements Action {
    readonly type = ADD_FAILED;

    constructor(public payload: any) { }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: ProjectSet) { }
}

export class UpdateCompleteAction implements Action {
    readonly type = UPDATE_COMPLETE;

    constructor(public payload: ProjectSet) { }
}

export class UpdateFailedAction implements Action {
    readonly type = UPDATE_FAILED;

    constructor(public payload: any) { }
}

export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: ProjectSet) { }
}

export class DeleteCompleteAction implements Action {
    readonly type = DELETE_COMPLETE;

    constructor(public payload: number) { }
}

export class DeleteFailedAction implements Action {
    readonly type = DELETE_FAILED;

    constructor(public payload: any) { }
}

export type Actions
    = AddAction
    | AddCompleteAction
    | AddFailedAction
    | UpdateAction
    | UpdateCompleteAction
    | UpdateFailedAction
    | DeleteAction
    | DeleteCompleteAction
    | DeleteFailedAction;
